<div class="launch-div d-flex flex-column justify-content-center m-4">
  @if (persistentError$ | async; as persistentError) {
    <div class="d-flex flex-column align-items-center">
      <i
        class="fa fa-5x fa-exclamation-circle launch-error-icon"
        aria-hidden="true"
      ></i>
      <div class="py-4 launch-error-text">
        <h4>{{ persistentError.title | translate }}</h4>
      </div>
    </div>
  } @else {
    <div
      class="spinner-border large"
      aria-live="polite"
      aria-atomic="true"
    ></div>
    <div class="py-4">
      <h4>{{ "Landing.LoadingQuestionnaire" | translate }}</h4>
    </div>
  }

  <app-launch-progress [stages]="stages$ | async"></app-launch-progress>
</div>

<app-footer></app-footer>
<div class="d-none">
  <form-renderer
    [questionnaire]="questionnaire"
    (onUnsupportedItems)="handleUnsupportedItems($event)"
  ></form-renderer>
</div>
